import produce from "immer";
import { CustomizationState } from "..";

export interface ChangePageOrderAction {
  type: "changePageOrder";
  pageKey: string;
  pageTarget: {
    pageKey: string;
    position: "after" | "before";
  };
}

export function changePageOrder(
  state: CustomizationState,
  action: ChangePageOrderAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { content } = draftState;

    let pageToMovePlace: number | null = null;
    let targetPlace: number | null = null;
    content.pages.forEach((contentPage, index) => {
      if (contentPage.key === action.pageKey) {
        pageToMovePlace = index;
        return;
      }
      if (contentPage.key === action.pageTarget.pageKey) {
        if (action.pageTarget.position === "after") {
          targetPlace = index + 1;
        } else {
          targetPlace = index;
        }
        return;
      }
    });
    if (pageToMovePlace === null || targetPlace === null) {
      return;
    }
    const diffTargetPlace = targetPlace > pageToMovePlace ? 1 : 0;
    const pageToMove = content.pages.splice(pageToMovePlace, 1)[0];
    content.pages.splice(targetPlace - diffTargetPlace, 0, pageToMove);
  });
}
